import { Action } from '@ngrx/store';
import { THLBoardInfoActionType } from './hl-board.models';
import {
  TREQUEST_HL_BOARD_LISTING,
  TREQUEST_OPL_CAPACITIES_INFO,
  TREQUEST_OTL_CAPACITIES_INFO,
  TRESPONSE_DAILY_OPL_CAPACITIES,
  TRESPONSE_HL_BOARD_LISTING,
  TRESPONSE_OTL_CAPACITIES_INFO,
  TRESPONSE_WEEKLY_OPL_CAPACITIES,
} from '@monorepo/types';

export class GetHLBoardList implements Action {
  readonly type = THLBoardInfoActionType.GetHLBoardList;
  constructor(public payload: TREQUEST_HL_BOARD_LISTING) {}
}

export class GetHLBoardListSuccess implements Action {
  readonly type = THLBoardInfoActionType.GetHLBoardListSuccess;
  constructor(public payload: TRESPONSE_HL_BOARD_LISTING) {}
}

export class GetHLBoardListFailure implements Action {
  readonly type = THLBoardInfoActionType.GetHLBoardListFailure;
}

export class GetOTLCapacitiesInfo implements Action {
  readonly type = THLBoardInfoActionType.GetOTLCapacitiesInfo;
  constructor(public payload: TREQUEST_OTL_CAPACITIES_INFO) {}
}

export class GetOTLCapacitiesInfoSuccess implements Action {
  readonly type = THLBoardInfoActionType.GetOTLCapacitiesInfoSuccess;
  constructor(public payload: TRESPONSE_OTL_CAPACITIES_INFO) {}
}

export class GetOTLCapacitiesInfoFailure implements Action {
  readonly type = THLBoardInfoActionType.GetOTLCapacitiesInfoFailure;
}

export class GetWeeklyOPLCapacitiesInfo implements Action {
  readonly type = THLBoardInfoActionType.GetWeeklyOPLCapacitiesInfo;
  constructor(public payload: TREQUEST_OPL_CAPACITIES_INFO) {}
}

export class GetWeeklyOPLCapacitiesInfoSuccess implements Action {
  readonly type = THLBoardInfoActionType.GetWeeklyOPLCapacitiesInfoSuccess;
  constructor(public payload: TRESPONSE_WEEKLY_OPL_CAPACITIES) {}
}

export class GetWeeklyOPLCapacitiesInfoFailure implements Action {
  readonly type = THLBoardInfoActionType.GetWeeklyOPLCapacitiesInfoFailure;
}

export class GetDailyOPLCapacitiesInfo implements Action {
  readonly type = THLBoardInfoActionType.GetDailyOPLCapacitiesInfo;
  constructor(public payload: TREQUEST_OPL_CAPACITIES_INFO) {}
}

export class GetDailyOPLCapacitiesInfoSuccess implements Action {
  readonly type = THLBoardInfoActionType.GetDailyOPLCapacitiesInfoSuccess;
  constructor(public payload: TRESPONSE_DAILY_OPL_CAPACITIES) {}
}

export class GetDailyOPLCapacitiesInfoFailure implements Action {
  readonly type = THLBoardInfoActionType.GetDailyOPLCapacitiesInfoFailure;
}

export type THLBoardActions =
  | GetHLBoardList
  | GetHLBoardListSuccess
  | GetOTLCapacitiesInfo
  | GetOTLCapacitiesInfoSuccess
  | GetOTLCapacitiesInfoFailure
  | GetWeeklyOPLCapacitiesInfo
  | GetWeeklyOPLCapacitiesInfoSuccess
  | GetWeeklyOPLCapacitiesInfoFailure
  | GetDailyOPLCapacitiesInfo
  | GetDailyOPLCapacitiesInfoSuccess
  | GetDailyOPLCapacitiesInfoFailure;
